import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { MyCookieService } from '../../../../services/my-cookie.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dialog-cookie-confirm',
  templateUrl: './dialog-cookie-confirm.component.html',
  styleUrls: ['./dialog-cookie-confirm.component.css']
})
export class DialogCookieConfirm {

  cookieService: MyCookieService;
  constructor(
    @Inject(MyCookieService) cookieService: MyCookieService,
    public dialogRef: MatDialogRef<DialogCookieConfirm>,
    private router: Router) 
  { 
    this.cookieService = cookieService;
  }

  cookiePolicy(){
    this.dialogRef.close();
    this.router.navigateByUrl('/cookie-policy');
  }

}



// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/utilita/dialogs/dialog-cookie-confirm/dialog-cookie-confirm.component.ts